import ActionTypes from "./ActionTypes";

const getQueriesData = (payload) => {
  return {
    type: ActionTypes.GET_SUPPORT_QUERIES,
    payload,
  };
};

const delSupportQuery = (payload) => {
  return {
    type: ActionTypes.DEL_SUPPORT_QUERY,
    payload,
  };
};

const getDiscountCodesData = (payload) => {
  return {
    type: ActionTypes.GET_DISCOUNT_CODES,
    payload,
  };
};

const delDiscountCode = (payload) => {
  return {
    type: ActionTypes.DEL_DISCOUNT_CODE,
    payload,
  };
};

const addDiscountCode = (payload) => {
  return {
    type: ActionTypes.ADD_DISCOUNT_CODE,
    payload,
  };
};

const getWebQueriesData = (payload) => {
  return {
    type: ActionTypes.GET_WEB_QUERIES,
    payload,
  };
};

export {getQueriesData , delSupportQuery, getDiscountCodesData, delDiscountCode, addDiscountCode, getWebQueriesData};
